const state = {
	stepErrors: {
		intro: false
	}
}
const mutations = {
	setIntroError: (state, value) => {
		state.stepErrors.intro = value
	}
}
const actions = {}

export default {
	state,
	mutations,
	actions
}
